import React from 'react';
import Gallery from "react-photo-gallery-react17";
import { useTranslation } from 'react-i18next'

import {NavLink } from 'react-router-dom';


const GallerySandal = () =>{

    const { t, i18n } = useTranslation()



  const photos = [
    {}
  ];


  const photosTeak = [
    {
      src: "../images/gallerysandal/S1.jpg",
      width: 1,
      height: 1
    },
    {
      src: "../images/gallerysandal/S2.jpg",
      width: 1,
      height: 1
    },
    {
      src: "../images/gallerysandal/S3.jpg",
      width: 1,
      height: 1
     },
     {
        src: "../images/gallerysandal/S4.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S5.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S5.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S6.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S7.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S8.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S9.jpg",
        width: 1,
        height: 1
       },
       {
        src: "../images/gallerysandal/S10.jpg",
        width: 2,
        height: 1
       }


    ]

    return(
        <>

           <div className="container-fluid nav-bg" >
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div className="col-12 mx-auto bg-light">
                                <div class="p-1 w-auto h-25 bg-light "> 
                                    <strong>
                                      <NavLink to="/Gallery" >
                                        {t('menu.gallery')}
                                      </NavLink>
                                      - {t('gallery.sandalwood')}
                                    </strong>
                                </div>
                                <div className="p-1"></div>
                                <div>
                                    <Gallery photos={photosTeak}/>
                                </div>


                        </div>
                    </div>
                </div>
            </div> 

        </>
    );
}

export default GallerySandal